// Component
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ISystemState } from 'model/system/systemReducer';
import { SelectBox, typeValuesListItem } from 'components/UI/SelectBox/SelectBox';
import { LANGUAGE, languageList } from 'locales/languages';
import { languageAC } from 'model/system/systemActionCreators';

import { Trans } from '@lingui/macro';


export const LanguageSettings: React.FC = () => {

    const dispatch = useDispatch()
    const currentLang = useSelector((state: { system: ISystemState }) => state.system.language)


    //change language
    const languages: typeValuesListItem[] = [
        { id: LANGUAGE.RU, name: languageList[LANGUAGE.RU] },
        { id: LANGUAGE.EN, name: languageList[LANGUAGE.EN] },
        { id: LANGUAGE.UZ, name: languageList[LANGUAGE.UZ] },
    ]


    // @ts-ignore
    const [ langValue, setLangValue ] = useState<LANGUAGE>(currentLang)


    useEffect(() => {
        if (langValue === null) {return}
        if (currentLang !== langValue) {
            dispatch(languageAC(langValue))
        }
        // eslint-disable-next-line
    }, [ langValue ])


    return (

        <div className={ 'flex flex-col gap-x-2' }>

            <div className="text-lg font-medium text-gray-500 tracking-wider  mr-4 pt-1"><Trans>Language</Trans>:
            </div>
            <div className="relative grid gap-4 grid-cols-1 sm:grid-cols-2">
                <SelectBox valuesList={ languages } valueId={ langValue } setIdValue={ setLangValue }
                           selectBosClassname={ 'sm:w-80 sm:col-span-2' }
                           labelClassname={ 'hidden' }

                />
            </div>

        </div>
    )
}
